import { render, staticRenderFns } from "./Side.vue?vue&type=template&id=f62d9f24&"
import script from "./Side.vue?vue&type=script&lang=js&"
export * from "./Side.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports